// extracted by mini-css-extract-plugin
module.exports = {"counter":"counter_counter__1haai","items":"counter_items__u0zGq","count":"counter_count__3aYlY","btn":"counter_btn__rIft_","footer":"counter_footer__1NbW7"};